import { useQuery } from '@tanstack/react-query';

type AdminImportRequest = {
  id: number;
  status: 'pending' | 'done' | string;
  organization_name: string | null;
  job_source_title: string | null;
  admin_user_name: string | null;
  created_at: string;
  updated_at: string;
};

type AdminImportRequestsResponse =
  | AdminImportRequest[]
  | {
      data?: AdminImportRequest[];
    };

const normalizeImportRequests = (payload: AdminImportRequestsResponse): AdminImportRequest[] => {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload.data ?? [];
};

export default function useFetchAdminImportRequests() {
  return useQuery({
    queryKey: ['admin', 'import_requests'],
    queryFn: async () => {
      const response = await fetch('/admin/api/import_requests');
      if (!response.ok) {
        throw new Error('求人クロールリクエスト一覧の取得に失敗しました');
      }
      const data: AdminImportRequestsResponse = await response.json();
      return normalizeImportRequests(data);
    },
  });
}
